import { render, staticRenderFns } from "./formcontent.vue?vue&type=template&id=0749d14a&scoped=true"
import script from "./formcontent.vue?vue&type=script&lang=js"
export * from "./formcontent.vue?vue&type=script&lang=js"
import style0 from "./formcontent.vue?vue&type=style&index=0&id=0749d14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0749d14a",
  null
  
)

export default component.exports